import { render, staticRenderFns } from "./affiliate-questions.vue?vue&type=template&id=0b4faeb3&scoped=true&"
import script from "./affiliate-questions.vue?vue&type=script&lang=ts&"
export * from "./affiliate-questions.vue?vue&type=script&lang=ts&"
import style0 from "./affiliate-questions.vue?vue&type=style&index=0&id=0b4faeb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4faeb3",
  null
  
)

export default component.exports